import {
    // Account,
    Bills,
    CashFlow,
    Categories,
    Dashboard,
    Discount,
    Employee,
    // Statistics,
    Login,
    Orders,
    Products,
    Reports,
    Settings,
    TableMap,
    // Ingredients,
    WarehouseRoute,
} from './screens';
import { RouteType } from './types';

export const privateRoutes: Array<RouteType> = [
    Dashboard,
    CashFlow,
    Reports,
    Bills,
    Orders,
    Discount,
    Categories,
    Products,
    WarehouseRoute,
    // Statistics,
    // Account,
    TableMap,
    Employee,
    Settings,
];

export const publicRoutes: Array<Omit<RouteType, 'icon'>> = [
    Login,
];
